import { Box, Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ReLogin = () => {
  const navigate = useNavigate();
  const handleLogin = () => {
    localStorage.setItem("isLoggedIn", true);
    navigate("/");
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      <div style={{ fontSize: "2rem" }}>
        Your session has timed out due to 20 minutes of inactivity
      </div>
      <div style={{ fontSize: "2rem" }}>
        Please click the button below to log back in{" "}
        <Button
          sx={{
            borderRadius: 4,
            minWidth: 100,
            minHeight: 50,
            background: "#102A62",
            marginTop: "13px",
            marginLeft: "10px",
          }}
          variant="contained"
          onClick={handleLogin}
        >
          Log In
        </Button>{" "}
      </div>
    </Box>
  );
};

export default ReLogin;
